import React, { MouseEvent } from 'react';


interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
  testId?: string;
}

const EditIcon = ({ className, onClick, testId }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" className={className} onClick={onClick} data-testid={testId}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#191B1E" fillRule="nonzero" transform="translate(-589 -593)">
          <g transform="translate(74 573)">
            <g transform="translate(515 20)">
              <path d="M17.765 12.031a.48.48 0 00-.48.48v4.256a1.44 1.44 0 01-1.437 1.438H2.397a1.44 1.44 0 01-1.438-1.438V4.275a1.44 1.44 0 011.438-1.438h4.256a.48.48 0 100-.96H2.397A2.4 2.4 0 000 4.276v12.492a2.4 2.4 0 002.397 2.397h13.45a2.4 2.4 0 002.398-2.397V12.51a.48.48 0 00-.48-.479z"></path>
              <path d="M18.055.644a2.157 2.157 0 00-3.051 0L6.452 9.197a.48.48 0 00-.124.21l-1.124 4.061a.48.48 0 00.59.59l4.06-1.125a.48.48 0 00.211-.123l8.552-8.552a2.16 2.16 0 000-3.051l-.562-.563zM7.496 9.508l7-7 2.257 2.258-7 7-2.257-2.258zm-.45.905l1.803 1.804-2.495.69.691-2.494zM17.938 3.58l-.508.508-2.258-2.257.509-.509a1.198 1.198 0 011.695 0l.562.563a1.2 1.2 0 010 1.695z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EditIcon;
